import { callAPI } from '../../../../services/api.service';

export interface ProjectStudentMigrationResponse {
  status: number;
  message: string;
  data?: {
    totalStudents: number;
    migrated: number;
    skipped: number;
    errors: number;
    errorDetails?: string[];
  };
}

export interface ProjectStudentValidationResponse {
  status: number;
  message: string;
  data?: {
    totalStudents: number;
    hasProjectRelations: number;
    missingRelations: number;
    missingStudents?: string[];
  };
}

export const startProjectStudentMigration = async (): Promise<ProjectStudentMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/migrate-project-students', {}, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to start project-student migration:', error);
    throw error;
  }
};

export const validateProjectStudentMigration = async (): Promise<ProjectStudentValidationResponse> => {
  try {
    const response = await callAPI('admin/migration/validate-project-students');
    return response;
  } catch (error: any) {
    console.error('Failed to validate project-student migration:', error);
    throw error;
  }
};

export const migrateSpecificClassroom = async (classroomId: string): Promise<ProjectStudentMigrationResponse> => {
  try {
    const response = await callAPI('admin/migration/migrate-classroom', { classroomId }, 'POST');
    return response;
  } catch (error: any) {
    console.error('Failed to migrate specific classroom:', error);
    throw error;
  }
};